import { atomFamily } from 'recoil';

/**
 * open, setOpen을 openId하나로 관리
 */
export const feventTimeAtomFamily = atomFamily<Date | null, string>({
  key: 'feventTimeAtomFamily',
  default: null,
});
